/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Decklists_AllInputs */



/**
* | output |
* | --- |
* | "All" |
*
* @param {Tfield_Decklists_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_decklists_all = /** @type {((inputs?: Tfield_Decklists_AllInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Decklists_AllInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tous")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Todos")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutti")
	return /** @type {LocalizedString} */ ("All")
});